export default "__VITE_ASSET__BG3Kg8fl__"